import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
// Material
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// RxJS
import { Observable, of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PharmacyGroupDrugService } from '../../../../../../../../core/lists';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-pharmacy-group-drug-edit-dialog',
  templateUrl: './drug-edit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PharmacyGroupDrugEditDialogComponent implements OnInit {
  // Public properties
  drugInput: FormControl;
  viewLoading = true;
  filteredDrugs: Observable<Array<any>>;
  selectedDrugs = [];
  autocompleteSub: Subscription;

  /**
   * Component constructor
   *
   * @param data: any
   * @param dialogRef: MatDialogRef<DrugEditDialogComponent>
   * @param pharmacyGroupDrugsService: PharmacyGroupDrugsService
   * @param cdr: ChangeDetectorRef
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PharmacyGroupDrugEditDialogComponent>,
    private pharmacyGroupDrugService: PharmacyGroupDrugService,
    private cdr: ChangeDetectorRef,
  ) {}

  /**
   * On init
   */
  ngOnInit() {
    this.viewLoading = false;
    this.drugInput = new FormControl();
    this.autocompleteSub = this.drugInput.valueChanges
      .pipe(
        switchMap(
          // tslint:disable-next-line:max-line-length
          (value) => this.pharmacyGroupDrugService.searchDrugs(value),
        ),
      )
      .subscribe((result) => {
        this.filteredDrugs = result.data ? of(this.filter(result.data)) : of([]);
        this.cdr.detectChanges();
      });
  }

  /**
   * Close dialog
   */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * Close dialog
   *
   * @param specId: any
   */
  closeDialog() {
    this.autocompleteSub.unsubscribe();
    if (this.selectedDrugs.length > 0) {
      this.dialogRef.close({
        drugs: this.selectedDrugs.map((drug) => {
          return {
            id: drug.id,
            name: drug.drug,
            ndc: drug.ndc,
          };
        }),
      });
    } else {
      this.dialogRef.close();
    }
  }

  displayDrug(drug: any) {
    if (drug) {
      return drug.drug;
    }
  }

  selectedDrug(drug: any) {
    this.selectedDrugs.push(drug);
    this.drugInput.setValue(null);
  }

  removeDrug(drug) {
    const index = this.selectedDrugs.indexOf(drug);
    if (index >= 0) {
      this.selectedDrugs.splice(index, 1);
    }
  }

  filter(drugs) {
    return drugs.filter(
      (drug) =>
        !this.selectedDrugs.find((d) => parseInt(d.id, 10) === drug.id) &&
        !this.data.drugs.find((d) => parseInt(d.drug_id, 10) === drug.id),
    );
  }

  /**
   * Returns page title
   */
  getTitle(): string {
    return 'PHARMACY_GROUP_DRUG.ADD_PHARMACY_GROUP_DRUGS';
  }
}
